import { render, staticRenderFns } from "./MessageCompact.vue?vue&type=template&id=29118724&scoped=true&"
import script from "./MessageCompact.vue?vue&type=script&lang=js&"
export * from "./MessageCompact.vue?vue&type=script&lang=js&"
import style0 from "./MessageCompact.vue?vue&type=style&index=0&id=29118724&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29118724",
  null
  
)

export default component.exports